import { createSelector } from 'reselect';
import { RootState } from 'services/store';

export const selectSlice = (state: RootState) => state.filters;

export const selectFiltersOpen = createSelector(selectSlice, (slice) => slice.open);

export const selectAvailabilityFilters = createSelector(selectSlice, (slice) => slice.availability);
